import { Box, Flex, Text } from "@chakra-ui/react";
import { Modal } from "antd";
import { CloseModalButton } from "components/Button/CloseModalButton";
import SelectTenant from "components/Input/SelectTenant";
import { useRegrasTenant } from "core/features/tenants/tenants.context";
import { useEffect, useState } from "react";
import FooterModal from "ui/components/Button/FooterModal";
import Toolbar from "ui/components/Toolbar";
import { FiltroManutencao } from "../ListagemManutencaoTable/hooks/useFiltroManutencao";
import DateRangePicker from "components/Input/DateRangePicker";

interface ModalFiltrosProps {
  isOpen: boolean;
  onClose: () => any;
  filtro: FiltroManutencao;
  onChangeFiltro: (filtro: Partial<FiltroManutencao>) => any;
  onReset: (filtro?: Partial<FiltroManutencao>) => any;
}

function ModalFiltros({
  isOpen,
  onClose,
  filtro,
  onChangeFiltro,
  onReset,
}: ModalFiltrosProps) {
  const { useSubtenantsViews } = useRegrasTenant();
  const [localFiltro, setLocalFiltro] = useState<FiltroManutencao>(filtro);

  useEffect(() => {
    setLocalFiltro(filtro);
  }, [filtro]);

  return (
    <Modal
      visible={isOpen}
      onCancel={onClose}
      className="antd-custom-header"
      title={
        <Toolbar title="Filtros avançados" onClose={onClose} border="0px" />
      }
      closable={false}
      width="900px"
      centered
      footer={
        <Flex
          justifyContent="end"
          align="center"
          gap="8px"
          alignContent="center"
          alignItems="center"
        >
          <CloseModalButton
            closeModalLabel="Fechar"
            close={onClose}
            mt="32px"
          />
          <FooterModal
            isDisabled={false}
            onSubmit={() => {
              onChangeFiltro(localFiltro);
            }}
            onClose={() => {
              onReset();
              onClose();
            }}
            showRegisterAnother={false}
            primaryButtonText="Filtrar"
            buttonCancelarText="Limpar filtros"
            isLoadingSave={false}
            showBorderTop={false}
          />
        </Flex>
      }
    >
      {useSubtenantsViews ? (
        <Box columnGap={2} mb="25px">
          <Text fontWeight="bold" mb="10px">
            Condomínio(s)
          </Text>
          <SelectTenant
            mode="multiple"
            onChange={(tenantsIds) => {
              setLocalFiltro((state) => ({ ...state, tenantsIds }));
            }}
            value={localFiltro.tenantsIds}
            allowClear
            placeholder="Todos os condomínios"
          />
        </Box>
      ) : null}

      <Box>
        <Text fontWeight="bold" mb="10px">
          Período
        </Text>

        <Flex columnGap={2}>
          <Box maxW="250px" w="100%">
            <DateRangePicker
              allowEmptyDates={{
                dataInicio: false,
                dataFim: false,
              }}
              onChange={(dataInicio, dataFim) => {
                setLocalFiltro((state) => ({
                  ...state,
                  dataInicio: dataInicio || "",
                  dataFim: dataFim || "",
                }));
              }}
              value={{
                dataInicio: localFiltro.dataInicio,
                dataFim: localFiltro.dataFim,
              }}
            />
          </Box>
        </Flex>
      </Box>
    </Modal>
  );
}

export default ModalFiltros;
